import { render, staticRenderFns } from "./TipForm.vue?vue&type=template&id=59c5e49c"
import script from "./TipForm.vue?vue&type=script&lang=js"
export * from "./TipForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports